<template>
  <div class="home">
    <!-- <img id="news-image" src="https://d2w9rnfcy7mm78.cloudfront.net/3445984/original_c4c795135ca0f9dd29708288edb7b0ff.png" width="20%"/> -->
     <div class="tile-thing">
     <world-tile
        title='3FACE'
        image='https://d2w9rnfcy7mm78.cloudfront.net/17796927/original_24263d7f4dcdb5a0f9a4b5793218abad.gif'
        pageLink = 'https://outland.art/3face/'
      />
     <world-tile
        title='LIFE AFTER BOB'
        image='https://d2w9rnfcy7mm78.cloudfront.net/18127274/original_574bd0101b733f05676d5e756b88870c.gif'
        pageLink = '/LAB'
      />
      <world-tile
        title='BOB (Bag Of Beliefs)'
        image='https://d2w9rnfcy7mm78.cloudfront.net/2663713/original_5961e121e6b2cc91b90ce77bda1563f8.jpg'
        pageLink = '/BOB'
      />
       <!-- <world-tile
        title='LIFE AFTER BOB'
        image='https://d2w9rnfcy7mm78.cloudfront.net/2648953/large_fedcbf0bde9fbb622d6df0c754da7520.png'
        pageLink = ''
      /> -->
       <world-tile
        title='EMISSARIES TRILOGY'
        image='https://d2w9rnfcy7mm78.cloudfront.net/3789555/original_dd0e28b3fd9ebe2f74f10d0a960cef9c.gif'
        pageLink = '/emissaries'
      />
       <world-tile
        title="EMISSARY'S GUIDE TO WORLDING"
        image='https://d2w9rnfcy7mm78.cloudfront.net/3688733/original_8f44b1f35fd10200cd04576197a52987.jpg'
        pageLink = 'http://worldto.live'
      />

  </div>
    <div class="top-section">

   <div class="head-block">
    <p>Since 2012, I've created a series of simulations that explore an agent’s capacity to deal with an ever-changing environment. These works culminated in the <a href="/emissaries"><i>Emissaries</i> trilogy</a>, which introduced a narrative agent - the emissary - whose motivation to enact a story was set into conflict with the open-ended chaos of the simulation. In 2019, I developed <a href="/bob "><i>BOB (Bag of Beliefs)</i></a>, a AI-driven creature whose personality, body, and life script evolve across exhibitions. Most recently, I directed <a href="/LAB" ><i>Life After BOB</i></a>, a 50min real-time anime built in the Unity game engine. I am the author of <a href="http://worldto.live" target="blank"><i>Emissary's Guide To Worlding</i></a>, a book exploring the psychology and techniques of creating living autonomous worlds.
    </p>
    <p>
     In 2015, I founded <a href="http://metissuns.com" target="blank">Metis Suns</a>, a production company dedicated to Worlding and <a href="https://www.ribbonfarm.com/2019/03/05/worlding-raga-2-what-is-a-world/" target="blank">worlding literacy</a>.
    </p>
     <p>
     In 2024, I founded <a href="https://opponent.systems/" target="blank">Opponent Systems</a>, a new company building animal-level AI playmates for kids and families.
    </p>
<div class="videoWrapper">
    <iframe width="560" height="349" src="https://www.youtube.com/embed/vCc2djR25hg" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
</div>

<div class="videoWrapper">
<iframe src="https://player.vimeo.com/video/807896343?h=2357e044ef" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
</div>

   </div>
  </div>

    <recent-xbts />
   <!--  <h3>Images</h3>
        <images
              channelSlug = 'bob-drawings'
        /> -->
        <!--
        <images
              channelSlug = 'efap'
        />
        <images
              channelSlug = 'eitsog'
        />
      -->

        <!-- example child component -->
        <!-- <exhibition-tile
          title='Emissarieshudsiahdsauidhsa'
          location='MoMA PS1'
          date="April 9, 2017–Semptember 25, 2017"
          image="http://iancheng.com/image.php?height=300&image=https://dl.dropboxusercontent.com/s/joi81p9r80au4g8/emissaries_banner_blue.jpg"
          text="1. What is a simulation? It is an imitation of reality’s complexity. It is a model of a system. It is a rehearsal run before the big event. It is a video game that plays itself." /> -->

        <!-- example child component, from this component's data -->
        <!-- <exhibition-tile v-for="(xbt, index) in tiles" :key="index" :title="xbt.title" :location="xbt.subtitle" :date="xbt.date" :image="xbt.image" :text="xbt.text" /> -->
  </div>
</template>

<script>
// @ is an alias to /src
import WorldTile from '@/components/worldTile.vue'
import RecentXbts from '@/components/RecentXbts'
// import ExhibitionTile from '@/components/ExhibitionTile.vue'
// import Images from '@/views/Images.vue'

export default {
  name: 'Home',
  components: { RecentXbts, WorldTile },
  data () {
    return {
      tiles: [
        {
          title: 'EMISSARY FORKS AT PERFECTION',
          subtitle: 'live simulation and story',
          date: '2015-2016',
          image: 'http://iancheng.com/image.php?height=300&image=https://dl.dropboxusercontent.com/s/325zxk65tgo4avh/EFAP_14.jpg',
          text: "<p>Emissary Forks At Perfection takes place many thousands of years in the future, the volcano now a fertile Darwinian playground managed by an AI. During its post-mortem analysis on humankind, AI resurrects the remains of a 21st century human celebrity into this unrecognizable world and sends Shiba Emissary, a canine superpet, to extract one final impression of man under stress.</p><p>Emissary Forks At Perfection is composed of two contradictory forms: a simulation of a darwinian playground disturbed by an atavistic human; and a deterministic story of an emissary's emerging consciousness. Pushed together to oc py the same landscape, each form threatens to destabilize and mutate the other. Here, a story may escape its classical fixity and indefinitely procrastinate its conclusion. A simulation may find itself sculpted by narrative needs into sequences of controlled chaos. A sudden pattern of feelings may grow inside you, with or without you.</p>"
        },
        {
          title: 'Something Thinking Of You',
          subtitle: 'live streaming on Vdrome',
          date: '1 - 31 August 2015',
          image: 'http://iancheng.com/image.php?height=300&image=https://dl.dropboxusercontent.com/s/3pjkr43y61de4ur/something_thinking_of_you_iancheng_graph.jpg',
          text: '<p><i>Forking at Perfection</i> Mousse 49</p><p>Baby Island Simulator is a little game for encounters with a baby. To play this game you need a human baby who cannot yet walk, placed on a large isolated surface like a bed or a kitchen island. You also need the presence of sympathetic adults. Now you do nothing. The game is painful at first because Baby instinctively expects an adult gaze and your adultness must fight the instinct to give attention back to Baby. After a few seconds, Baby looks worried, fidgets around, reaches for something, fails, looks at you hopelessly, and inevitably begins to cry. You must remain indifferent. From Baby’s perspective, everything breaks down. The game everyone agreed to play since birth is suddenly without the right players or behaviors. But don’t worry, Baby isn’t a mechanism that risks repeating a single behavior to death. Baby is a complex organism. The crying eventually stops. Faced with an open-ended game called living, Baby begins to play with what its got. Sometimes Baby even invents new ways of getting attention, or turns objects into adults. Where did that come from? You can barely hide your delight. But you must keep silent, emit no love, and let the game continue to evolve. You observe how the mismatch between habituated ability and novel situation produces ridiculous, pathetic, undignified, creative behaviors, all of which are irreducible to any one aspect of the game. You can’t explain it, but what has happened here has emerged truthfully.</p>'
        }
      ]
    }
  }
}
</script>

<style scoped>

#big-image{
  width: 100%;
}

ul{
  padding-left: 2.5em;
  text-indent:-2.5em;
  width: 100%;
}

.head-block{
  border-radius: 7px;
  padding-bottom: 12px;
  padding-top: 12px;
      // border: 1.2px solid rgb(204, 204, 204);
      // box-shadow: 3px 3px 8px #ddd;
  // max-width: 30em;

}

.top-section{
  float:left;
  clear:both;
    width: 100%;
 font-size: 1.25em;
  border-bottom: 1px solid #ddd;

}

.tile-thing {
  float:center;
  clear: both;
  width: 100%;
  padding-top: 10px;

}

#news-image{
  margin: auto;
   display: block;
  text-align: left;
}
</style>
